const DOCUMENT = 'TALENT_ACCREDITATION_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  TOGGLE_DOCUMENT_MODAL: DOCUMENT + 'TOGGLE_DOCUMENT_MODAL',
  LOAD_DOCUMENT_REQUEST: DOCUMENT + 'LOAD_DOCUMENT_REQUEST',
  LOAD_DOCUMENT_SUCCESS: DOCUMENT + 'LOAD_DOCUMENT_SUCCESS',
  LOAD_DOCUMENTS: DOCUMENT + 'LOAD_DOCUMENTS',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  toggleDocumentModal: data => ({
    type: actions.TOGGLE_DOCUMENT_MODAL,
    payload: data,
  }),

  loadDocumentRequest: data => ({
    type: actions.LOAD_DOCUMENT_REQUEST,
    payload: data,
  }),

  loadDocumentSuccess: data => ({
    type: actions.LOAD_DOCUMENT_SUCCESS,
    payload: data,
  }),

  loadDocuments: data => ({
    type: actions.LOAD_DOCUMENTS,
    payload: data,
  }),

  sendRequest: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
